import { render } from "./WebhookHistoryTrigger.vue?vue&type=template&id=7a64205c"
import script from "./WebhookHistoryTrigger.vue?vue&type=script&lang=js"
export * from "./WebhookHistoryTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script